import {Injectable} from "@angular/core";

@Injectable()
export class OptionsService {
  public options = [10, 15, 25, 50];
}
